








import Vue from 'vue';
import PlusIcon from '@/assets/img/icons/plus.svg';
import { Spark } from 'sparkello-core';
import { DreamWebDAO, WebSpark } from '@/web';

export default Vue.component( 'AddSpark', {
  name: 'AddSpark',
  props: {
    styleClass: String,
    spark: WebSpark,
    size: String,
  },
  components: {PlusIcon},
  methods: {
    addSparkToMyDreams(spark: Spark) {
      console.log('Add spark to my dreams list ', spark.id);
      DreamWebDAO.getInstance().addSparkToMyDreams(spark);
      this.$router.push('/dreams');
    },
    sizeClass(): string {
      if (this.size == 'small') {
        return 'icon-sm-responsive'
      } else if (this.size == 'large') {
        return 'icon-lg-responsive'
      }
      return 'icon-responsive'
    },
  },
});
